module.exports = __webpack_public_path__ + "static/xwyz-logo-99cfbed7efbef0e894a0f45c16ad72f3.webp";